export const getYandexLang = (lang: string) => {
  switch (lang) {
    case 'ru':
      return 'ru_RU';
    default:
      return 'en_US';
  }
};
